import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    viewBox: "0 0 700 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<path fill="#E3DFDB" d="M64 8h53v8H64zm306 0h97v8h-97zm143 0h53v8h-53z"/> <path stroke="#E3DFDB" d="M636 24.5H64"/> <path fill="#E3DFDB" d="M64 36h181v16H64zm306 0h70v16h-70zm142 0h113v16H512zM64 76h223v16H64zm306 0h70v16h-70zm142 0h68v16h-68zM64 116h150v16H64zm306 0h70v16h-70zm142 0h103v16H512z"/>' }
  })
);